module.exports = __webpack_public_path__ + "static/media/icon1.535f5908.svg";